
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { isSuperAdmin } from "@/lib/auth";

export const SuperAdminRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user || !isSuperAdmin(user)) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};
